module.exports = __webpack_public_path__ + "static/media/aemet_inst_neg_rgb.c60831b3.png";